import type { CustomIconProps } from '../types';

const ProgressBar = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? 32}
        height={height ?? 32}
        viewBox="0 0 32 32"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.156631 7.12495C0.0701262 6.81189 0.263719 6.48958 0.589032 6.40506L6.64657 4.83112L13.0938 28.1635L31.0977 23.4855C31.423 23.401 31.7569 23.5863 31.8434 23.8993C31.9299 24.2124 31.7363 24.5347 31.411 24.6192L12.229 29.6033L5.78177 6.27091L0.902294 7.53875C0.576981 7.62327 0.243136 7.43801 0.156631 7.12495Z"
            fill="#414042"
        />
        <path
            d="M8.26636 12.9746L24.6723 8.71184L29.0683 24.6207L12.6623 28.8835L8.26636 12.9746Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.52051 12.5608L25.1045 7.99193L29.8138 25.0345L12.2297 29.6033L7.52051 12.5608ZM9.01183 13.3884L13.0945 28.1636L28.3224 24.2069L24.2397 9.43171L9.01183 13.3884Z"
            fill="#414042"
        />
        <path
            d="M16.2046 17.8408L14.5562 11.875L19.1703 10.6761L20.8188 16.6419L18.1454 15.9156L16.2046 17.8408Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8103 11.4612L19.6025 9.95618L21.6836 17.4875L18.3276 16.5758L15.8914 18.9925L13.8103 11.4612ZM15.3016 12.2888L16.5175 16.6891L17.9628 15.2554L19.9536 15.7963L18.7377 11.396L15.3016 12.2888Z"
            fill="#414042"
        />
        <path
            d="M17.9448 24.6696C18.6732 27.3055 17.0601 30.0148 14.3418 30.7211C11.6236 31.4274 8.82961 29.8631 8.10126 27.2272C7.37291 24.5914 8.98603 21.882 11.7043 21.1758C14.4225 20.4695 17.2165 22.0337 17.9448 24.6696Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0286 29.5874C16.0877 29.0524 17.3244 26.9936 16.7668 24.9757C16.2092 22.9578 14.0767 21.7744 12.0175 22.3094C9.95837 22.8445 8.72173 24.9032 9.27932 26.9212C9.83692 28.9391 11.9694 30.1224 14.0286 29.5874ZM14.3418 30.7211C17.0601 30.0148 18.6732 27.3055 17.9448 24.6696C17.2165 22.0337 14.4225 20.4695 11.7043 21.1758C8.98603 21.882 7.37291 24.5914 8.10126 27.2272C8.82961 29.8631 11.6236 31.4274 14.3418 30.7211Z"
            fill="#414042"
        />
    </svg>
);

export default ProgressBar;
